import { render, staticRenderFns } from "./thirdChannelList.vue?vue&type=template&id=7ca86182&scoped=true"
import script from "./thirdChannelList.vue?vue&type=script&lang=js"
export * from "./thirdChannelList.vue?vue&type=script&lang=js"
import style0 from "./thirdChannelList.vue?vue&type=style&index=0&id=7ca86182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca86182",
  null
  
)

export default component.exports